export default __webpack_public_path__ + "static/from_the_bench-min-1aac8431031ff33a04a5569e5f7a6c5f.png";